import React from 'react';
import { Col, Container, Image, Row } from 'react-bootstrap';
import QueryForm from '../../../Pages/Static/queryForm';
import AlorBanner from '../../../../Assets/images/alicias-img/alor.png';
import AlorBannerMobile from '../../../../Assets/images/alicias-img/alor-mobile.png';
import { isMobileOnly } from 'react-device-detect';

const NovelDesignStudio = () => {
  return (
    <>
      <div className="watch_repaire_services_page">
        <Container fluid>
          <Row>
            <Col sm={12} md={12} lg={12} className="p-0">
              <div>{isMobileOnly ? <Image src={AlorBannerMobile} className="img-fluid"  alt='Oris' /> : <Image src={AlorBanner} className="img-fluid"  alt='Oris' />}</div>
            </Col>
          </Row>

          <div className="text-center pt-5">
            <Row className="justify-content-center">
              <Col lg={8}>
                <h3 className="text-center text-uppercase">Novel Design Studio</h3>
                <p>Discover unparalleled elegance with Novel Design Studio Jewelry. Each piece is a testament to modern sophistication and distinctive design, meticulously crafted to elevate your style. Embrace the allure of unique creations that redefine contemporary jewelry, as Novel Design Studio brings innovation and artistic flair to every masterpiece.</p>
              </Col>
            </Row>
          </div>
        </Container>
        <QueryForm />
      </div>
    </>
  );
};

export default NovelDesignStudio;
